import React from 'react';
import { PhotoIcon } from './PhotoIcon';
import { PencilIcon } from './PencilIcon';

interface ReadinessChipProps {
  type: 'visuals' | 'copy';
  percent: number;
}

export const ReadinessChip = React.memo(function ReadinessChip({ type, percent }: ReadinessChipProps) {
  const isReady = percent >= 100;
  const color = isReady ? 'var(--peach)' : 'var(--light)';

  return (
    <div className="flex items-center gap-2">
      {type === "visuals" ? <PhotoIcon size={14} color={color} /> : <PencilIcon size={14} color={color} />}
      <span className={`text-sm fw-600`} style={{ color }}>
        {isReady
          ? `${type === 'visuals' ? 'Visuals' : 'Copy'} Ready`
          : `${type === 'visuals' ? 'Visuals' : 'Copy'} ${percent}%`}
      </span>
    </div>
  );
});
